// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-item h1 {
  font-size: 22px;
  line-height: 30px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
  margin-bottom: 20px;
  padding-top: 8px;
}
.help-item h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}
.help-item h3 {
  font-size: 16px;
}
.help-item img {
  max-width: 900px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: 4px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
